import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faShare } from "@fortawesome/pro-solid-svg-icons";

const joyrideSteps = [
  {
    target: ".jr-bird-icon",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-text">
          <p>
            This is the flythrough tool. Anytime you want a refresher or info
            about a new feature, tap here!
          </p>
        </div>
      </div>
    ),
    disableBeacon: true,
    styles: {
      options: {
        width: 300
      }
    }
  },
  {
    target: ".jr-foh-boh-toggle",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-text">
          <p>Press here to switch between front and back of house.</p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-settings",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-text">
          <p>Inside your settings you can log out of the tool if needed.</p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-high-risk",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-text">
          <p>
            This is your bakery's High Risk Rotation report. Check here to see
            which products need to be removed from display.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-home",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-text">
          <p>Tap here to return home and send to till.</p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  // {
  //   target: ".jr-wave-planner",
  //   content: (
  //     <div className="react-joyride__tooltip-content hlpr-flexbox">
  //       <div className="joyride-text">
  //         <p>
  //           <strong>Wave Planner</strong>
  //         </p>
  //         <p>
  //           This is your forecasted production schedule for today - catch those
  //           waves to maximise availability and freshness!!
  //         </p>
  //       </div>
  //     </div>
  //   ),
  //   disableBeacon: true
  // },
  // {
  //   target: ".jr-kpi-bar",
  //   content: (
  //     <div className="react-joyride__tooltip-content hlpr-flexbox">
  //       <div className="joyride-image">
  //         <div className="joyride-character joyride-character--pigeon"></div>
  //       </div>
  //       <div className="joyride-text">
  //         <p>
  //           The "KPI" bar gives you a snap shot for how well your bakery is
  //           doing for "Availability", "Freshness" (time on display) and "Waste".
  //           Tap the bar to see a full report.
  //         </p>
  //       </div>
  //     </div>
  //   ),
  //   disableBeacon: true
  // },
  // {
  //   target: ".jr-kpi-products",
  //   content: (
  //     <div className="react-joyride__tooltip-content hlpr-flexbox">
  //       <div className="joyride-image">
  //         <div className="joyride-character joyride-character--pigeon"></div>
  //       </div>
  //       <div className="joyride-text">
  //         <p>
  //           See what you're best at making... Tap any product title to for a KPI
  //           report on individual products.
  //         </p>
  //       </div>
  //     </div>
  //   ),
  //   disableBeacon: true
  // },
  // {
  //   target: ".jr-opportunity-badge",
  //   content: (
  //     <div className="react-joyride__tooltip-content hlpr-flexbox">
  //       <div className="joyride-image">
  //         <div className="joyride-character joyride-character--pigeon"></div>
  //       </div>
  //       <div className="joyride-text">
  //         <p>
  //           You may spot some red and yellow dots here—no need to call the
  //           doctor! These are opportunity badges, highlighting areas where you
  //           can improve.
  //         </p>
  //       </div>
  //     </div>
  //   ),
  //   disableBeacon: true
  // },
  {
    target: ".jr-search-input",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon"></div>
        </div>
        <div className="joyride-text">
          <p>
            <strong>Let's talk about searching products...</strong>
          </p>
          <p>Filter by name or category to quickly find the items you need.</p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  // {
  //   target: ".jr-clear-search",
  //   content: (
  //     <div className="react-joyride__tooltip-content hlpr-flexbox">
  //       <div className="joyride-image">
  //         <div className="joyride-character joyride-character--pigeon-smoking"></div>
  //       </div>
  //       <div className="joyride-text">
  //         <p>Touch this to clear the search bar and view all items again.</p>
  //       </div>
  //     </div>
  //   ),
  //   disableBeacon: true
  // },
  {
    target: ".jr-re-order",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon"></div>
        </div>
        <div className="joyride-text">
          <p>
            To make finding your products even easier, you can sort by any
            column.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-waves-help",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon-smoking"></div>
        </div>
        <div className="joyride-text">
          <p>Tap here for a full explanation of the Planner Widget.</p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-target",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon-smoking"></div>
        </div>
        <div className="joyride-text">
          <p>
            By default, products are ordered by target time. This is ideal as it
            provides an ordered production list for the entire day.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-sent",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-text">
          <p>
            This column shows you how many of each item has been sent to the
            till today.
          </p>
        </div>
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon-flying"></div>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-already-made",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="react-joyride__demo">
            <div className="hlpr-text-align-center">
              <span className="already-made__total strong">54</span>
            </div>
            <span className="already-made__wave already-made__target already-made__target--min-wavesX">
              12
            </span>
            <span className="already-made__wave already-made__target already-made__target--rec-wavesX">
              24
            </span>
            {/* <span className="already-made__wave already-made__target already-made__target--missing">
              &nbsp;
            </span> */}
          </div>
        </div>
        <div className="joyride-text">
          <p className="strong">Baking Waves</p>
          <p>
            When you "send to till" it creates a wave. Your wave breakdown will
            appear below your "total sent" value. The circles represent your
            waves.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  // {
  //   target: ".jr-already-made",
  //   content: (
  //     <div className="react-joyride__tooltip-content hlpr-flexbox">
  //       <div className="joyride-image">
  //         <div className="react-joyride__already-made-demo">
  //           <div className="hlpr-text-align-center">
  //             <span className="already-made__total strong">54</span>
  //           </div>
  //           <span className="already-made__wave already-made__target already-made__target--min-waves">
  //             12
  //           </span>
  //           <span className="already-made__wave already-made__target already-made__target--rec-waves">
  //             24
  //           </span>
  //           <span className="already-made__wave already-made__target already-made__target--missing">
  //             &nbsp;
  //           </span>
  //         </div>
  //       </div>
  //       <div className="joyride-text">
  //         <p className="strong">Wave Colours</p>
  //         <p>
  //           <strong>Amber:</strong> Minimum standard. This is expected across
  //           all bakeries.
  //         </p>
  //         <p>
  //           <strong>Grey:</strong> Recommended swell! Optimum waves, tailored to
  //           your bakery.
  //         </p>
  //         <p>
  //           <strong>Red:</strong> Missed wave! You’re falling behind during the
  //           target window.
  //         </p>
  //       </div>
  //     </div>
  //   ),
  //   disableBeacon: true
  // },
  {
    target: ".jr-already-made",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="react-joyride__demo">
            <div className="hlpr-text-align-center">
              <span className="already-made__total strong">54</span>
            </div>
            <span className="already-made__wave already-made__target already-made__target--min-wavesX">
              12
            </span>
            <span className="already-made__wave already-made__target already-made__target--rec-wavesX">
              24
            </span>
            {/* <span className="already-made__wave already-made__target already-made__target--rec-waves">
              &nbsp;
            </span> */}
            <div className="freshness">
              <div className="freshness-time small">01:22</div>
              <div className="freshness-bar">
                <div
                  className="freshness-bar__energy bar-medium"
                  style={{ width: "65%" }}
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div className="joyride-text">
          <p className="strong">Safety Rotation</p>
          <p>
            The "rotation bar" signals when products need to be restocked on the
            baker's table. For food safety, ensure this is done before the timer
            runs out.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-target-window",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon-smoking"></div>
        </div>
        <div className="joyride-text">
          <p>
            This is your "availability target window". Ensure products are well
            stocked and fresh during these times. Completed windows will appear
            at the bottom of the target list.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-units-steps",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon"></div>
        </div>
        <div className="joyride-text">
          <p>
            <strong>How many units have been made?</strong>
          </p>
          <p>Enter the quantity by going up and down in steps of 1 or 5.</p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-units-type",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon-smoking"></div>
        </div>
        <div className="joyride-text">
          <p>
            Or if you prefer, you can type in the amount using the popup
            keyboard. Please double check values entered are correct.
          </p>
          <p>No negative values allowed</p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-temp-check-column",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon"></div>
        </div>
        <div className="joyride-text">
          <p>
            <strong>Temperature Checks</strong>
          </p>
          <p>
            Some items require a food safety temperature check. These checks
            must be completed as soon as the food comes out of the oven,
            following the guidelines in the Bakers Book.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-temp-check-column",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon-smoking"></div>
        </div>
        <div className="joyride-text">
          <p>
            The product units column will remain locked until a temperature
            check is saved.
          </p>
          <p>
            Enter your initials, record the temperature, and tap save to
            timestamp the check. You can return later to submit the units to the
            till as usual.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-temp-check-column",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon"></div>
        </div>
        <div className="joyride-text">
          <p>
            Weekly temperature checks only need to be completed with your first
            submission of the day.
          </p>
          <p>
            If you make a mistake on any check, tap the small 'X' to clear and
            redo.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-reset",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon"></div>
        </div>
        <div className="joyride-text">
          <p>
            <strong>Let's get this food out</strong>
          </p>
          <p>
            Press the reset button if you want to set all your units back to
            zero. What's been previously sent to till won't be affected.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-send",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-text">
          <p>
            <strong>You're good to go!</strong>
          </p>
          <p>
            Time to send the quantities to the till and take your items to the
            baker's table. Don't worry if the WiFi drops, the tool will keep
            re-trying upto ten times. Keep an eye out for a green success
            notification but if all fails, you'll get a red warning message.
          </p>
        </div>
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon-flying"></div>
        </div>
      </div>
    ),
    disableBeacon: true
  }
];

export { joyrideSteps };

const joyrideStepsWaves = [
  {
    target: ".jr-waves",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon-smoking"></div>
        </div>
        <div className="joyride-text">
          <p>
            <strong>Welcome to the Wave Planner</strong>
          </p>
          <p>
            We've built a virtual brain to help you maximise profit. It provides
            forecasts based on historical sales data and ingredient orders.
            Remember, it's a tool, not a rule.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-waves-head",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon"></div>
        </div>
        <div className="joyride-text">
          <p>
            The columns represent each hour of your bakery's day, with the
            current hour highlighted in red.
          </p>
          <p>To view products ordered by this hour just tap it!</p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-waves-head-totals",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon-smoking"></div>
        </div>
        <div className="joyride-text">
          <p>
            The totals column does what it says: it shows the total units sent
            to the till compared to the total units forecasted. Just remember,
            it's Sent / Forecast.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-waves-body",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon"></div>
        </div>
        <div className="joyride-text">
          <p>
            These are your planned or forecasted units for this product
            throughout today. Submitted units are compared to forecasted units.
          </p>
          <p>
            The data team will measure how closely you stick to the forecast, so
            follow the suggestions as best you can.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-slot",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon-smoking"></div>
        </div>
        <div className="joyride-text">
          <strong>Adjust the plan</strong>
          <p>
            If you're a BM, you <strong>might</strong> know your bakery even
            better than our virtual brain. To make a change, simply tap any time
            slot—whether it's empty or filled—and a popup will guide you through
            the adjustment.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  // {
  //   target: ".jr-slot",
  //   content: (
  //     <div className="react-joyride__tooltip-content hlpr-flexbox">
  //       <div className="joyride-image">
  //         <div className="joyride-character joyride-character--pigeon-smoking"></div>
  //       </div>
  //       <div className="joyride-text">
  //         <strong>Help the brain improve</strong>
  //         <p>
  //           If you don't trust or want to follow the forecast, please tap any
  //           time slot, whether it's empty or not, to share your thoughts. A
  //           quick response box will appear with options for you to choose from.
  //         </p>
  //       </div>
  //     </div>
  //   ),
  //   disableBeacon: true
  // },
  {
    target: ".jr-waves-view",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-text">
          <p>
            Lastly, tapping here will expand all columns and show you every time
            slot.
          </p>
        </div>
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon-flying"></div>
        </div>
      </div>
    ),
    disableBeacon: true
  }
];

export { joyrideStepsWaves };

const joyrideStepsRotation = [
  {
    target: ".jr-rotation-name",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon-smoking"></div>
        </div>
        <div className="joyride-text">
          <p>
            This page tracks products with a limited display time for safety
            reasons. Check here to see which items need to be removed and when.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-rotation-rotation",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-text">
          <p>
            The amount of time this wave of products can stay on display before
            they become unsafe to consume.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-rotation-start",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-text">
          <p>The time this batch was displayed for sale.</p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-rotation-end",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-text">
          <p>
            The latest time any remaining items in this wave should be removed
            to ensure safety.
          </p>
          <p>If this number turns red, act fast and clear them out!</p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-rotation-qty",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-text">
          <p>The quantity recorded by the baker for this batch.</p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-rotation-temp",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="joyride-character joyride-character--pigeon"></div>
        </div>
        <div className="joyride-text">
          <p>
            Some products need a temperature check before being displayed. You
            can verify them here.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-rotation-bar",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image joyride-image--high-risk-demo">
          <div className="react-joyride__demo react-joyride__demo--high-risk-demo">
            <div className="hlpr-flexbox bakery-table--high-risk-rotation__freshness bakery-table--high-risk-rotation">
              <div className="freshness ">
                <div className="freshness-time small">01:25</div>
                <div className="freshness-bar">
                  <div
                    className="freshness-bar__energy bar-high"
                    style={{ width: "70%" }}
                  ></div>
                </div>
              </div>
              <button className="hlpr-clear-input clear-rotation">
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          </div>
        </div>
        <div className="joyride-text">
          <p>
            Just like on the home screen, these bars show you when it's time to
            remove food from display.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-rotation-bar",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image joyride-image--high-risk-demo">
          <div className="react-joyride__demo react-joyride__demo--high-risk-demo">
            <div className="hlpr-flexbox bakery-table--high-risk-rotation__freshness bakery-table--high-risk-rotation">
              <div className="freshness ">
                <div className="freshness-time small">00:12</div>
                <div className="freshness-bar">
                  <div
                    className="freshness-bar__energy bar-low"
                    style={{ width: "8%" }}
                  ></div>
                </div>
              </div>
              <button className="hlpr-clear-input clear-rotation">
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          </div>
        </div>
        <div className="joyride-text">
          <p>
            Tap 'X' to clear the rotation bar before the timer runs out or when
            the batch has sold out. This helps the other Bread Heads know that
            this wave has been taken care of.
          </p>
        </div>
      </div>
    ),
    disableBeacon: true
  },
  {
    target: ".jr-rotation-bar",
    content: (
      <div className="react-joyride__tooltip-content hlpr-flexbox">
        <div className="joyride-image">
          <div className="react-joyride__demo">
            <div className="hlpr-flexbox hlpr-flexbox-center">
              <FontAwesomeIcon icon={faShare} />
            </div>
          </div>
        </div>
        <div className="joyride-text">
          <p>Remember to keep the till and Vita Mojo Hub in sync.</p>
          <p>If you made a mistake, no worries—just tap the redo arrow!</p>
        </div>
      </div>
    ),
    disableBeacon: true
  }
];

export { joyrideStepsRotation };

const joyrideStyles = {
  options: {
    arrowColor: "#f5f5ed",
    backgroundColor: "#f5f5ed",
    overlayColor: "rgba(0, 0, 0, 0.5)",
    primaryColor: "#cf2030",
    textColor: "#cf2030",
    width: 500,
    zIndex: 100
  }
};

export { joyrideStyles };
